import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "clm-act-cntn" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Atur ")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down text-black ml-4" }, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

import EmptyState from '@/views/components/list/EmptyState.vue'
import Card from 'primevue/card'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import OverlayPanel from 'primevue/overlaypanel'
import ProgressSpinner from 'primevue/progressspinner'
import HeaderCustom from '@/views/components/header/HeaderHjpTable.vue'
import { onMounted, reactive, ref, computed, getCurrentInstance, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import InputSwitch from 'primevue/inputswitch'
import Paginator from '@/views/components/paginator/Paginator.vue'
import ListActions from '@/views/components/list/ListActions.vue'
import { useRouter } from 'vue-router'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import HjpSideBar from '@/views/components/sidebar/HjpSideBar.vue'
import IResponse from '@/utils/interfaces/iResponse'
import Form from './Form.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const partnerEndpoint = 'management/v2/Partners'
const moduleStore = 'hjpTable'

const store = useStore()
const router = useRouter()
const app = getCurrentInstance()
const {
  $toast, $strInd
} = app!.appContext.config.globalProperties
const headerTitle = ref('Master Partner')
const buttonTitle = ref('Tambah Partner')
const searchPlaceholder = ref('Cari Disini...')
const emptyTable = ref('Data belum ada, silahkan tambah untuk mengisi data')
const showSearch = ref(true)
const showBtnAdd = ref(true)
const isLoading = ref(false)
const showModalForm = computed({
  get: () => store.state[moduleStore].modal.show,
  set: (value) => {
    store.dispatch('setShowModal', value)
  }
})
const showConfirmDialog = ref(false)
const dataRow = ref(null) as any
const refOverlayAction = ref()
const dataSource = ref([])
const filters = reactive({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  custom: [] as any,
  totalRecords: 0
})
const confirmDialogDelete = ref({
  title: 'Hapus Partner?',
  subTitle: 'Data partner tersebut akan dihapus dalam sistem. Yakin hapus partner?',
  btnSubmitTitle: 'Hapus Partner',
})

const hideDialogConfirmation = () => {
  showConfirmDialog.value = false
}

const onSearch = (val: any) => {
  console.log('search', val)
  filters.search = val
  filters.pageNumber = 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const onClickBtnAdd = () => {
  showModalForm.value = true
}

const changeIsActive = async (data: any) => {
  console.log('data', data)
  const payload = {
    Id: data.Id,
    Code: data.Code,
    Name: data.Name,
    Email: data.Email,
    PhoneNumber: data.PhoneNumber,
    RateLimit: 0,
    IsActive: data.IsActive,
    MsUserId: data.MsUserId,
    MsPassengerId: data.MsPassengerId,
    Notes: data.Notes
  }

  const response = await apiUseCase.put(`${partnerEndpoint}/${data.Id}`, payload)
  if (!response.error) {
    $toast.add({
      severity: 'success',
      summary: 'Partner berhasil diubah!',
      detail: 'Data partner di sistem telah berhasil diperbaruhi',
      group: 'bc',
      life: 3000
    })
  } else {
    $toast.add({
      severity: 'error',
      detail: response.message,
      group: 'bc',
      life: 3000
    })
    data.IsActive = !data.IsActive
  }
}

const showDropDown = (evt: any, item: any) => {
  dataRow.value = item
  console.log('evt', evt)
  refOverlayAction.value.toggle(evt)
}

const hideOverlay = () => {
  refOverlayAction.value.hide()
}

const setDataRowOnState = () => {
  // console.log('dataRow', dataRow.value)
  store.dispatch('storeRowDataTable', dataRow.value)
}

const onDelete = () => {
  showConfirmDialog.value = true
  setDataRowOnState()
  hideOverlay()
}

const onEdit = () => {
  showModalForm.value = true
  setDataRowOnState()
  hideOverlay()
}

const hideModalForm = () => {
  showModalForm.value = false
  dataRow.value = null
}

const viewPartnerAgreement = () => {
  hideOverlay()
  setDataRowOnState()
  const idPartner = encryptDecriptMethods.encrypt(dataRow.value)
  setTimeout(() => {
    router.push({
      name: 'partner-agreement',
      params: {
        id: idPartner
      }
    })
  }, 500)
}

const getAllData = () => {
  store.dispatch('showLoading')
  isLoading.value = true
  dataSource.value = []
  apiUseCase.get(`${partnerEndpoint}${returnUrlPrams(filters)}`).then((response) => {
    const {
      error,
      result,
      count
    } = response
    if (!error) {
      filters.totalRecords = count
      dataSource.value = result
    }
    isLoading.value = false
  }).then((err: any) => {
    isLoading.value = false
  })
  store.dispatch('hideLoading')
}

const onChangePage = (val: any) => {
  filters.pageNumber = val.page + 1
  getAllData()
}

const submitFromDialog = (val: any = '') => {
  store.dispatch('showLoading')
  const deletedId = val === '' ? dataRow.value.Id : val
  apiUseCase.delete(partnerEndpoint, deletedId).then((res: IResponse) => {
    if (!res.error) {
      $toast.add({
        severity: 'success',
        summary: 'Partner berhasil dihapus!',
        detail: 'Data partner telah berhasil dihapus dalam sistem',
        group: 'bc',
        closable: false,
        life: 3000
      })
      getAllData()
    } else {
      $toast.add({
        severity: 'error',
        detail: $strInd.toast.errorPartnerHasActiveAgreement,
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  dataRow.value = null
  setDataRowOnState()
  hideDialogConfirmation()
  store.dispatch('hideLoading')
}

onMounted(() => {
  getAllData()
})

onBeforeMount(() => {
  store.dispatch('partnerAgreement/flushPartnerAgreement')
  store.dispatch('storeRowDataTable', null)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(HeaderCustom, {
            titleHeader: headerTitle.value,
            titleButton: buttonTitle.value,
            onRedirectAdd: onClickBtnAdd,
            placeholder: searchPlaceholder.value,
            onOnSearch: onSearch,
            showSearch: showSearch.value,
            showAddBtn: showBtnAdd.value
          }, null, 8, ["titleHeader", "titleButton", "placeholder", "showSearch", "showAddBtn"])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(DataTable), {
          id: "hjp-data-table",
          value: dataSource.value,
          paginator: false,
          loading: isLoading.value,
          class: "table-og hjp-data-table",
          responsiveLayout: "scroll"
        }, {
          empty: _withCtx(() => [
            _createVNode(EmptyState, { textNoData: emptyTable.value }, null, 8, ["textNoData"])
          ]),
          loading: _withCtx(() => [
            _createVNode(_unref(ProgressSpinner), { style: {"width":"70px","height":"70px"} })
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Column), { header: "Nama" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("p", null, _toDisplayString(slotProps.data.Name ?? '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Email" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("p", null, _toDisplayString(slotProps.data.Email ?? '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Telepon" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("p", null, _toDisplayString(slotProps.data.PhoneNumber ?? '-'), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Jumlah Kontrak" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("p", null, _toDisplayString(slotProps.data.PartnerAgreementsCount ?? 0) + " Kontrak", 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), { header: "Aktif" }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(InputSwitch), {
                    modelValue: slotProps.data.IsActive,
                    "onUpdate:modelValue": ($event: any) => ((slotProps.data.IsActive) = $event),
                    onChange: ($event: any) => (changeIsActive(slotProps.data))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "",
              class: "colom-action mx-auto"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "px-4 py-2 flex items-center cursor-pointer rounded-lg background-grey-lighten-5",
                    onClick: ($event: any) => (showDropDown($event, slotProps.data))
                  }, _hoisted_7, 8, _hoisted_4)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"]),
        _createVNode(_unref(OverlayPanel), {
          ref_key: "refOverlayAction",
          ref: refOverlayAction
        }, {
          default: _withCtx(() => [
            _createVNode(ListActions, {
              edit: true,
              del: true,
              viewPartnerAgreement: true,
              editTitle: 'Edit Partner',
              viewPartnerAgreementTitle: 'Lihat Kontrak',
              delTitle: 'Hapus',
              onDel: onDelete,
              onEdit: onEdit,
              onViewPartnerAgreement: viewPartnerAgreement
            })
          ]),
          _: 1
        }, 512)
      ]),
      footer: _withCtx(() => [
        (filters.totalRecords > 0)
          ? (_openBlock(), _createBlock(Paginator, {
              key: 0,
              rows: filters.pageSize,
              totalRecords: filters.totalRecords,
              onOnPage: onChangePage
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(HjpSideBar, {
      show: _unref(showModalForm),
      canDelete: false,
      onHideDialog: hideModalForm
    }, {
      form: _withCtx(() => [
        _createVNode(Form, { onReloadHeader: getAllData })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(HjpCofirmModal, {
      show: showConfirmDialog.value,
      title: confirmDialogDelete.value?.title,
      subTitle: confirmDialogDelete.value?.subTitle,
      btnSubmitTitle: confirmDialogDelete.value?.btnSubmitTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: submitFromDialog
    }, null, 8, ["show", "title", "subTitle", "btnSubmitTitle"])
  ]))
}
}

})